import React, { useEffect } from 'react'
import env from '../../../Config'


import './Webstyles.scss'


const WebDevelopment = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className='container-fluid base-pad pt-0'>
      <div>
        <img src={env.baseUrl + '/images/web-development-1.jpg'} className='img-fluid' />
      </div>
      <div>
        <div className='navibluebox-row'>
          <div className='bigcol'>
            <h6 class="sec-heading text-uppercase">Web Development</h6>
            <h2 className='base-h1'> Web Development services</h2>
            <p>Web Development services help businesses build fast, secure, responsive, and high-performing websites tailored to their unique goals. We combine modern technologies, clean design, and user-focused development practices to create websites that deliver seamless experiences across desktops, tablets, and mobile devices. From business websites and e-commerce platforms to custom web applications and scalable solutions, our team handles every stage of development, including planning, UI/UX integration, development, testing, and deployment. With a focus on SEO, performance, security, scalability, and usability, we create websites that strengthen your online presence, engage customers, and support long-term business growth.</p>
            <h3>Our Web Development services include:</h3>
            <div className='d-lg-flex d-md-flex justify-content-between'>
              <ul>
                <li className='py-2'>Custom Web Development</li>
                <li className='py-2'>Responsive Design</li>
                <li className='py-2'>Website Maintenance and Support</li>
              </ul>
              <ul>
                <li className='py-2'>E-Commerce Solutions</li>
                <li className='py-2'>Content Management Systems (CMS)</li>
              </ul>
            </div>

          </div>
          <div className='smallcol minus'>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/custom-web.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>custom web</h4>
                </div>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/e-commerce.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>E-Commerce Solutions</h4>
                </div>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/responsive.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>Responsive Design</h4>
                </div>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/cms.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>Content Management Systems (CMS)</h4>
                </div>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/support.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>Website Maintenance and Support</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-light'>
        <div className='container sec-pad'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1'>
              <img src={env.baseUrl + '/images/custom-webdevelopment.jpg'} className='img-fluid img-cust' />
            </div>
            <div className='col-lg-6 order-lg-2'>
              <div className='r-box'>
                <h3>Custom Web Development</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    Custom Web Development services deliver tailored, scalable, and high-performance web solutions designed around your unique business requirements. We go beyond standard templates to build custom websites, web applications, business platforms, and integrated digital solutions that align with your workflows and goals. Our experienced developers use modern technologies and best practices to ensure every solution is responsive, secure, SEO-friendly, fast, and easy to maintain. From initial planning and UI/UX development to coding, API integration, testing, and deployment, we provide end-to-end web development services that help businesses improve efficiency, enhance customer experiences, and achieve sustainable digital growth.
                  </p>
                </div>
                <div>
                  <h4>Why Choose Custom Web Development?</h4>
                  <ul>
                    <li>Personalization</li>
                    <li>Scalability</li>
                    <li>Optimized Performance</li>
                    <li>Enhanced Security</li>
                    <li>Integration Capabilities</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='sec-pad'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1'>
              <div className='l-box'>
                <h3> E-Commerce Solutions</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    CodexCore, we build secure, responsive, and user-friendly e-commerce solutions that help businesses sell online and grow their digital presence. From custom online stores and secure payment integration to product management and seamless checkout, we create scalable platforms designed to improve customer experience, sales, and business growth.
                  </p>
                </div>
                <div>
                  <h4>Why Choose E-Commerce Solutions?</h4>
                  <ul>
                    <li>Global Reach</li>
                    <li>24/7 Accessibility</li>
                    <li>Scalability</li>
                    <li>Personalized Shopping Experience</li>
                    <li>Data-Driven Insights</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='col-lg-6 order-lg-2'>
              <img src={env.baseUrl + '/images/e-commerce.jpg'} className='img-fluid' />
            </div>
          </div>
        </div>
      </div>

      <div className='bg-light'>
        <div className='container sec-pad'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1'>
              <img src={env.baseUrl + '/images/responsive.jpg'} className='img-fluid img-cust' />
            </div>
            <div className='col-lg-6 order-lg-2'>
              <div className='r-box'>
                <h3>Responsive Design</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    At CodexCore, we create responsive web designs that provide a seamless and engaging experience across desktops, tablets, and mobile devices. Our mobile-friendly designs adapt smoothly to different screen sizes, ensuring fast performance, easy navigation, and consistent visual appeal. This helps businesses improve user experience, SEO performance, customer engagement, and online conversions.
                  </p>
                </div>
                <div>
                  <h4>Why Choose Responsive Design?</h4>
                  <ul>
                    <li>Enhanced User Experience</li>
                    <li>Improved SEO Performance</li>
                    <li>Cost-Effectiveness</li>
                    <li>Future-Proofing</li>
                    <li>Accessibility Compliance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='sec-pad'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1'>
              <div className='l-box'>
                <h3>Content Management Systems (CMS)</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    we provide user-friendly Content Management System (CMS) solutions using platforms like WordPress, Joomla, and Drupal, making it easy to manage and update your website content. Our CMS solutions offer flexibility, scalability, and simple content management, helping businesses maintain a professional and up-to-date online presence without requiring advanced technical skills.
                  </p>
                </div>
                <div>
                  <h4>Why Choose a Content Management System?</h4>
                  <ul>
                    <li>Ease of Use</li>
                    <li>Efficiency and Productivity</li>
                    <li>Flexibility and Customization</li>
                    <li>Scalability</li>
                    <li>SEO-Friendly</li>
                  </ul>
                </div>
              </div>

            </div>
            <div className='col-lg-6 order-lg-2'>
              <img src={env.baseUrl + '/images/cms.jpg'} className='img-fluid' />
            </div>

          </div>
        </div>

      </div>
      <div className='sec-pad'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1'>
              <img src={env.baseUrl + '/images/website-maintenance.jpg'} className='img-fluid img-cust' />
            </div>
            <div className='col-lg-6 order-lg-2'>
              <div className='r-box'>
                <h3>Website Maintenance and Support</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    Website Maintenance and Support services keep your website secure, updated, fast, and running smoothly. We handle regular updates, security checks, performance optimization, bug fixes, backups, and technical support to ensure your website remains reliable and effective.
                  </p>
                </div>
                <div>
                  <h4>Our Website Maintenance and Support Services Offer</h4>
                  <ul>
                    <li>24/7 Monitoring</li>
                    <li>Technical Support</li>
                    <li>Regular Maintenance Tasks</li>
                    <li>Emergency Response</li>
                    <li>Consultation and Recommendations</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>
  )
}

export default WebDevelopment